import SEO from "@/components/SEO";
import { LegalNotice } from "@/pages/Impressum";
import { CONTACT } from "@/data/services";

export default function Datenschutz() {
  return (
    <>
      <SEO
        title="Datenschutzerklärung | ZWILLINGSWERK Herten"
        description="Datenschutzerklärung von ZWILLINGSWERK: Diese Website verwendet keine Tracking-Cookies. Informationen zur Datenverarbeitung nach DSGVO."
      />
      <section className="py-16 bg-[#F8FAF8]" data-testid="datenschutz-page">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <h1 className="text-3xl sm:text-4xl font-black text-[#122B18] font-display">Datenschutzerklärung</h1>
          <LegalNotice />

          <div className="bg-white border border-[#D7E5D9] rounded-xl p-6 space-y-6 text-sm text-[#4A634E] leading-relaxed">
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">1. Verantwortlicher</h2>
              <p>
                ZWILLINGSWERK – Garten- &amp; Hausmeisterservice, {CONTACT.street}, {CONTACT.city}
                <br />
                Telefon: {CONTACT.phoneDisplay} · E-Mail: {CONTACT.email}
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">2. Cookies & Tracking</h2>
              <p>
                Diese Website verwendet <strong>keine Tracking-Cookies</strong> und keine Analyse-Tools. Es findet kein
                Nutzer-Tracking statt.
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">3. Kontaktaufnahme</h2>
              <p>
                Bei Kontaktaufnahme per Telefon oder E-Mail verarbeiten wir Ihre Angaben (Name, Kontaktdaten, Anliegen)
                ausschließlich zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b DSGVO). Eine Weitergabe an Dritte
                erfolgt nicht.
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">4. Kartenmaterial</h2>
              <p>
                Zur Darstellung unseres Standorts binden wir Kartenmaterial von OpenStreetMap ein. Beim Aufruf der Karte
                werden technisch bedingt Daten (z. B. IP-Adresse) an die Server der OpenStreetMap Foundation
                übertragen. [Platzhalter: Details vor Livegang prüfen]
              </p>
            </div>
            <div>
              <h2 className="text-base font-bold text-[#122B18] mb-2">5. Ihre Rechte</h2>
              <p>
                Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung,
                Datenübertragbarkeit sowie Widerspruch. Zudem besteht ein Beschwerderecht bei der zuständigen
                Aufsichtsbehörde (LDI NRW).
              </p>
              <p className="mt-2">
                [Platzhalter: Vollständige DSGVO-Erklärung vor Livegang durch geprüften Mustertext ersetzen.]
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
